import Phaser from 'phaser';
import { GAME_WIDTH, GAME_HEIGHT } from './config';
import { BootScene } from './scenes/BootScene';
import { CharacterCreateScene } from './scenes/CharacterCreateScene';
import { HomeScene } from './scenes/HomeScene';
import { ClosetScene } from './scenes/ClosetScene';
import { MiniGameHubScene } from './scenes/MiniGameHubScene';
import { ShopScene } from './scenes/ShopScene';
import { DressUpChallengeScene } from './scenes/minigames/DressUpChallengeScene';
import { ColorMatchScene } from './scenes/minigames/ColorMatchScene';
import { RhythmGameScene } from './scenes/minigames/RhythmGameScene';
import { MemoryScene } from './scenes/minigames/MemoryScene';
import { ShoppingRushScene } from './scenes/minigames/ShoppingRushScene';
import { WalkingTimingScene } from './scenes/minigames/WalkingTimingScene';
import { OutfitPuzzleScene } from './scenes/minigames/OutfitPuzzleScene';
import { MathChallengeScene } from './scenes/minigames/MathChallengeScene';
import { RunwayScene } from './scenes/RunwayScene';
import { PetRoomScene } from './scenes/PetRoomScene';
import { QuestPanelScene } from './scenes/QuestPanelScene';
import { CollectionScene } from './scenes/CollectionScene';
import { HUDScene } from './scenes/HUDScene';
import { LoadingScene } from './scenes/LoadingScene';

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game',
  width: GAME_WIDTH,
  height: GAME_HEIGHT,
  backgroundColor: '#fef0f5',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    // Use window.innerHeight (the visual viewport) rather than the full page height.
    // This means the game always fits inside the visible area on mobile,
    // even when the browser address bar is present.
  },
  pixelArt: true,
  dom: { createContainer: true },
  scene: [BootScene, CharacterCreateScene, HomeScene, ClosetScene, MiniGameHubScene, ShopScene, ColorMatchScene, RhythmGameScene, MemoryScene, ShoppingRushScene, WalkingTimingScene, OutfitPuzzleScene, DressUpChallengeScene, MathChallengeScene, RunwayScene, PetRoomScene, QuestPanelScene, CollectionScene, HUDScene, LoadingScene],
};

const game = new Phaser.Game(config);

// ──────────────────────────────────────────────────────────────────────────────
// 뒤로가기 차단 로직
//
// 브라우저/안드로이드 swipe-back은 popstate를 발생시킴.
// 핵심 전략: history stack에 여러 개의 dummy state를 쌓아 두어,
// 사용자가 여러 번 뒤로가기를 눌러야만 실제 페이지를 떠날 수 있도록 함.
//
// PWA fullscreen 모드에서는 브라우저 UI 자체가 없으므로 swipe-back 제스처도
// 없어져 이 문제가 자동 해결됨. (PWA 설치 권장)
//
// 주의: beforeunload는 모바일 브라우저에서 대부분 무시되므로 보조용으로만 사용.
// ──────────────────────────────────────────────────────────────────────────────

const SCENES_TO_HOME = ['ClosetScene', 'MiniGameHubScene', 'ShopScene', 'RunwayScene', 'PetRoomScene', 'CollectionScene',
  'DressUpChallengeScene', 'ColorMatchScene', 'RhythmGameScene', 'MemoryScene', 'ShoppingRushScene',
  'WalkingTimingScene', 'OutfitPuzzleScene', 'MathChallengeScene', 'LoadingScene'];

/** history stack에 N개의 dummy state를 밀어 넣음. */
function pushBufferStates(n = 5): void {
  for (let i = 0; i < n; i++) {
    history.pushState({ rohas: true, buf: i, ts: Date.now() }, '');
  }
}

// 페이지 로드 시 여러 개의 버퍼 state 추가
window.addEventListener('load', () => { pushBufferStates(5); });

// popstate — 뒤로가기(또는 swipe-back) 발생 시
window.addEventListener('popstate', () => {
  // 즉시 여러 state를 다시 쌓아 다음 popstate도 잡음
  // (n=3은 한 번의 popstate에 대한 최소 완충; 계속 쌓이므로 누적 효과 있음)
  pushBufferStates(3);

  // 현재 활성 scene 찾기
  const activeScenes = game.scene.getScenes(true);
  const inSubScene = activeScenes.some(s => SCENES_TO_HOME.includes(s.scene.key));

  if (inSubScene) {
    // 서브 scene이면 HUDScene 정리하고 HomeScene으로 전환
    activeScenes.forEach(s => {
      if (s.scene.key === 'HUDScene') game.scene.stop('HUDScene');
      if (SCENES_TO_HOME.includes(s.scene.key)) game.scene.stop(s.scene.key);
    });
    if (!game.scene.isActive('HomeScene')) {
      game.scene.start('HomeScene');
    }
  }
  // 이미 Home이면 아무것도 안 함 (사이트 떠나지 않음 — 버퍼가 다음 popstate 흡수)
});

// beforeunload: 일부 데스크톱 브라우저에서 '사이트를 떠나겠습니까?' 다이얼로그 표시
// 모바일(Galaxy Tab)에서는 보통 무시되지만 PWA 모드에서는 불필요
window.addEventListener('beforeunload', (e) => {
  e.preventDefault();
  // Chrome requires returnValue to be set
  e.returnValue = '';
});

// QuestPanelScene 같은 오버레이 닫기에도 활용 가능 (추후)
